export default {
    methods: {
        getId() {
            const _ga = this.$cookies.get('_ga');
            const _gid = this.$cookies.get('_gid');
            const _nid = this.$cookies.get('_nid');

            if (_ga !== null) {
                const res = _ga.split(".");
                return res[2] + '.' + res[3];
            } else if (_gid !== null) {
                const res = _gid.split(".");
                return res[2] + '.' + res[3];
            } else if (_nid !== null) {
                return _nid;
            } else {
                const _nid = Math.round(Math.random() * 10000000000).toString() + '.' + Math.round(Math.random() * 10000000000).toString();
                this.$cookies.set("_nid",_nid,"2y");
                this.$cookies.set("_ga",`GA1.2.${_nid}`,"2y");
                return _nid;
            }
        }
    }
};